import el from "@cypherpotato/el";
import page from "page";
import { Button } from "../../components/button";
import { Card, CardContent, CardHeader } from "../../components/card";
import { CommandBar } from "../../components/command-bar";
import { Dashboard, DashboardTitle } from "../../components/dashboard";
import { FormControl, TextInput } from "../../components/form";
import { displayFormControl } from "../../ui/alert";
import { Icon } from "../../components/icon";
import { Section } from "../../components/layout";
import { SegmentBar } from "../../components/progress-bar";
import { DefaultRow, Table, TableActionCell, TableBody, TableCell, TableHeader, TableHeaderActionCell, TableHeaderCell, TableRow } from "../../components/table";
import { CopiableText } from "../../components/text";
import { formatDateTime } from "../../ui/format";
import { runOperation } from "../../ui/operation";
import { api } from './../../api';
import { throttledCall } from './../../ui/throttle';
import { SpecializedControl } from "../../components/specializedObject";

export default function (ctx) {

    const collections = el.state.create(null);
    const filter = el.state.create("");

    function refreshTable() {
        runOperation("Fetching collections...", async () => {
            const response = await api.getJson("/api/v1/collections");
            collections.value = response.data;
        });
    }

    refreshTable();

    return Dashboard(
        DashboardTitle(
            "Collections",
            "Here you can view and manage your collections."
        ),
        Section(
            CommandBar(
                Button(Icon("add-line"), "New collection", {
                    onClick() {
                        displayFormControl({
                            title: "Create new collection",
                            message: "Fill in the details to create a new collection.",
                            formControlItem: SpecializedControl({
                                fields: [
                                    {
                                        label: "Collection name",
                                        name: "collectionName",
                                        control: TextInput(null, null, {
                                            placeholder: "E.g. My knowledge base"
                                        })
                                    }
                                ]
                            }),
                            onConfirm(data) {
                                runOperation("Creating collection...", async () => {
                                    await api.postJson("/api/v1/collections", data);
                                    refreshTable();
                                });
                            },
                            validate: [
                                [x => x.collectionName.trim().length >= 3, "Collection name must be at least 3 characters long."]
                            ]
                        })
                    }
                })
            ),
        ),
        Section(
            CommandBar(
                FormControl(null,
                    TextInput("searchInput", "Filter columns...", {
                        onInput(event) {
                            throttledCall(() => {
                                filter.value = event.target.value;
                            }, 300);
                        }
                    })
                )
            )
        ),
        Section(
            Card(
                { class: "bg-card" },
                CardHeader("My collections"),
                CardContent(
                    Table(
                        TableHeader(
                            TableHeaderCell("Id."),
                            TableHeaderCell("Name"),
                            TableHeaderCell("Created at"),
                            TableHeaderCell("Current state"),
                            TableHeaderActionCell("Actions")
                        ),
                        el.state.listening([collections, filter], () =>
                            TableBody(
                                (collections.value || [])
                                    .filter(item => item.name.toLowerCase().includes(filter.value.toLowerCase()))
                                    .map(item =>
                                        TableRow(
                                            TableCell(CopiableText(
                                                '#' + item.id.substr(-4), item.id
                                            )),
                                            TableCell(item.name),
                                            TableCell(formatDateTime(item.createdAt)),
                                            TableCell(
                                                SegmentBar({
                                                    autosize: true,
                                                    segments: [
                                                        {
                                                            label: "Indexed",
                                                            value: item.documentCount.indexedDocuments - item.documentCount.outdatedDocuments,
                                                            color: "limegreen"
                                                        },
                                                        {
                                                            label: "Queued",
                                                            value: item.documentCount.queuedDocuments,
                                                            color: "orange"
                                                        },
                                                        {
                                                            label: "Outdated",
                                                            value: item.documentCount.outdatedDocuments,
                                                            color: "indianred"
                                                        }
                                                    ]
                                                })
                                            ),
                                            TableActionCell(
                                                Button(
                                                    Icon("arrow-right-double-line"),
                                                    "View",
                                                    {
                                                        onClick() {
                                                            page(`/dashboard/collections/${item.id}/documents`);
                                                        }
                                                    }
                                                )
                                            )
                                        )
                                    )?.nullWhenEmpty() || DefaultRow("No collections found.")
                            )
                        )
                    )
                )
            )
        )
    )
}
